<template>
  <div class="course-page">
    <div class="course-page__inner">
      <!-- carregando -->
      <page-skeleton v-if="loading" variant="list" class="mt-4" />

      <template v-else>
        <ModuleHero :module="course" :show-back="true" @back="goBack" />

        <p class="sec-label">{{ $t("moduleLessons.lessons") }}</p>
        <div v-if="lessons.length > 0" class="list">
          <LessonRow
            v-for="(item, index) in lessons"
            :key="item.id || index"
            :item="item"
            :accent="accent"
            :order="index + 1"
            @open="goToLesson"
          />
        </div>
        <div v-else class="course-page__state">
          <span>{{ $t("moduleLessons.empty") }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ModuleHero from "@/components/connect/course/ModuleHero.vue";
import LessonRow from "@/components/connect/course/LessonRow.vue";
import { tierColor } from "@/shared/courseTiers";
import pitchCustomerApi from "@/shared/pitchCustomerApi";

export default {
  name: "ModuleLessons",
  components: {
    ModuleHero,
    LessonRow,
  },
  async created() {
    await this.loadModule();
  },
  data() {
    return {
      loading: true,
      course: {},
      lessons: [],
    };
  },
  computed: {
    accent() {
      return tierColor(this.course.level);
    },
  },
  methods: {
    async loadModule() {
      this.loading = true;
      await pitchCustomerApi
        .getCourseModule(this.$route.params.id)
        .then((response) => {
          this.course = response.data.module;
          this.lessons = response.data.module.classes || [];
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (this.redirectWhileAwaitingTutor(err)) return;
          this.$root.$emit("display-alert", {
            text: this.$t("moduleLessons.loadFailed"),
            type: 2,
            timeout: 1500,
          });
        });
    },
    // Aluno solo sem tutor: a API recusa o material com 422 (e não 403, que
    // desconectava o aluno). /curso explica a espera pelo tutor.
    redirectWhileAwaitingTutor(err) {
      if (err?.response?.status !== 422) return false;
      this.$root.$emit("display-alert", {
        text:
          err.response.data?.message || this.$t("moduleLessons.awaitingTutor"),
        type: 0,
        timeout: 2500,
      });
      this.$router.replace({ path: "/connect/aluno/curso" });
      return true;
    },
    goToLesson(item) {
      this.$router.push({
        path: "/connect/aluno/curso/" + item.id,
      });
    },
    goBack() {
      this.$router.push({ path: "/connect/aluno/curso" });
    },
  },
  watch: {
    "$route.params.id"() {
      this.loadModule();
    },
  },
};
</script>

<style scoped>
.course-page {
  padding: clamp(20px, 4vw, 44px) clamp(16px, 4vw, 40px) 72px;
}
.course-page__inner {
  max-width: 1180px;
  margin: 0 auto;
}
.sec-label {
  margin: 0 0 18px;
  font-family: "Poppins", sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.course-page__state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 0;
  font-family: "Poppins", sans-serif;
  color: var(--dk-ink-soft, #6e6a79);
  text-align: center;
}
</style>
